module.exports = __webpack_public_path__ + "static/media/giovany.ea4be6d6.png";